import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import AutoBindComponent from "../common/AutoBindComponent";
import * as layoutActions from "../../actions/layoutActions";
import * as exceptionActions from "../../actions/exceptionActions";
import ExceptionForm from "./ExceptionForm";

import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import Axios from "axios";

class ExceptionPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
	}

	componentWillMount() {
		this.props.loadLayout();
	}

	componentWillUnmount() {
		this.props.clearException();
	}
	
	componentDidMount() {
		const exception = this.props.exception;
		const serviceUrl = prependRoot("/tools/logerror", getApiRoot());

		const result = Axios.put(serviceUrl, {
			message: (exception.message ? `Message: ${exception.message}` : exception) + (exception.stack ? `  Stack: ${exception.stack}` : "")
		});
	}

	render() {
		return (
			<ExceptionForm exception={this.props.exception} contact={this.props.helpdeskContactLink}/>
		);
	}
}

ExceptionPage.propTypes = {
	exception: PropTypes.object,
	helpdeskContactLink: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		helpdeskContactLink: state.settings.helpdeskContactLink,
		exception: state.exception
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadExceptionPageLayout, dispatch),
		clearException: bindActionCreators(exceptionActions.clearException, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ExceptionPage);
